<template>
  <pdp-section-heading />
</template>

<script lang="ts" setup>
import PdpSectionHeading from '#brand/regions/nora/components/pdp/section/Heading.vue'

const { $feature } = useNuxtApp()
const { brandClasses } = useAppConfig().pages.pdp

if ($feature.tempShowATCAboveFold) {
  brandClasses.headingWrapper = 'f-col items-start gap-2 lg:gap-1'
  brandClasses.headingProductName = 'elevate-body-1 fw-bold lg:text-lg'
  brandClasses.headingExclusions = 'elevate-body-4 c-grey-30 lg:text-xs dark:c-grey-70'
  brandClasses.headingProductPricing = 'elevate-body-3 mt-4 lg:text-sm lg:not-first:mt-3'
}
</script>
